import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { Section, SectionContent, SectionHeader } from 'src/shared/components';

import TechnologiesCarousel from './components/TechnologiesCarousel/TechnologiesCarousel';
import styles from './TechnologiesSection.module.scss';

const TechnologiesSection = () => {
	const { t } = useTranslation();

	return (
		<Section name="technologies" animation="fadeIn" classes={{ section: styles.section }}>
			<SectionHeader
				title={t('technologiesSection.title')}
				description={
					<Fragment>
						<span dangerouslySetInnerHTML={{ __html: t('technologiesSection.description') }} />
					</Fragment>
				}
			/>
			<SectionContent animation="fadeInUp">
				<TechnologiesCarousel />
			</SectionContent>
		</Section>
	);
};

export default TechnologiesSection;
